import { InputHTMLAttributes } from "react";
import { FieldError } from "react-hook-form";
import { radio, RadioVariantProps } from "./radio.variants";

export type UseRadioProps = RadioVariantProps &
  InputHTMLAttributes<HTMLInputElement> & {
    className?: string;
    ref?: React.Ref<HTMLInputElement>;
    label?: string;
    error?: FieldError;
  };

export const useRadio = (props: UseRadioProps) => {
  const {
    ref,
    className = "",
    id,
    name,
    label,
    error,
    color = "light",
    ...componentProps
  } = props;

  const fieldId = id || name;
  const hasError = !!error;

  const styles = radio({ color, hasError });

  return {
    styles,
    className,
    fieldId,
    label,
    hasError,
    errorMessage: error?.message,
    color,
    componentProps: {
      ...componentProps,
      ref,
      name,
    },
  };
};
